import { API_NAME } from 'api/auth/constants'
import { authConstants } from 'constants/auth-constants'
import { User } from 'oidc-client-ts'
import UrlBuilder from 'services/util/url-builder'

export const GetSessionToken = () => {
	const authUrl: string = new UrlBuilder(API_NAME).url()
	const authority = authUrl
	const clientId = authConstants.clientId

	const oidcStorage = localStorage.getItem(`oidc.user:${authority}:${clientId}`)

	if (!oidcStorage) {
		return null
	}

	const user = User.fromStorageString(oidcStorage)

	return user.access_token
}
